import React from "react";
import { getStpDetailsTableColumns } from "./StpDetailsTableColumns";
import  Table from "../base-table";
import { StpDetails } from "../../graphql/graphql";
import type { TableRef } from "../base-table";

type StpDetailsTableProps = {
  data: StpDetails[];
  tableRef?: React.Ref<TableRef>;
  isLoading?: boolean;
  error?: string | null;
};

export const StpDetailsTable: React.FC<StpDetailsTableProps> = ({
  data,
  tableRef,
  isLoading,
  error,
}) => {
  const columns = React.useMemo(() => getStpDetailsTableColumns(), []);

  return (
    <Table
      tableRef={tableRef}
      columns={columns}
      data={data ?? []}
      isLoading={isLoading}
      error={error}
      enablePagination={false}
      enableRowSelection={false}
      meta={{}}
    />
  );
};